
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { finalize, catchError, switchMap, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { AppInsightsService } from '../services/common/app-insights.service';
import { SharedService } from '../services/common/shared.service';
import { environment } from '../../../environments/environment';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private count = 0;
  constructor(private auth: AuthService,
    private sharedservice: SharedService,
    private toastr: ToastrService,
    private appInsightsService: AppInsightsService) {

  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.count === 0) {
      this.sharedservice.isLoaderVisible = true;
    }
    this.count++;

    return this.auth.getToken().pipe(
      take(1),
      switchMap((token) => {
        let authRequest = request;
        if (token && request.url.startsWith(environment.url)) {
          authRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }
        return next.handle(authRequest);
      }),
      finalize(() => {
        this.count--;
        if (this.count === 0) {
          this.sharedservice.isLoaderVisible = false;
        }
      }),
      catchError(error => {
        this.appInsightsService.logError(error);
        if (error.status === 401) {
          this.auth.logoff();
        }
        const err = error?.error?.errors;
        for (var index in err) {
          this.toastr.error(err[index].message || error.message, error.status, { closeButton: true });
        }
        return throwError(error);
      }));
  }

}
